import React from "react";

const SvgAlertTriangle = props => <svg viewBox="0 0 16 16" fill="none" {...props}><path fillRule="evenodd" clipRule="evenodd" d="M1.665 15a1 1 0 0 1-.882-1.47L7.116 1.653a1 1 0 0 1 1.765 0l6.333 11.875A1 1 0 0 1 14.332 15H1.665zM7 6a1 1 0 1 1 2 0v3a1 1 0 0 1-2 0V6zm1 5a1 1 0 1 0 0 2 1 1 0 0 0 0-2z" fill="#647482" /></svg>;

export default SvgAlertTriangle;